"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvanceFilter = void 0;
const react_1 = __importStar(require("react"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const FilterContext = react_1.default.createContext({
    id: 'default',
    defaultFilter: {}
});
FilterContext.displayName = 'FilterContext';
const useAdvanceFilter = () => react_1.default.useContext(FilterContext);
exports.useAdvanceFilter = useAdvanceFilter;
const AdvanceFilter = ({ id, defaultFilter, children }) => {
    const setFilter = (0, useFilter_1.default)((state) => state.setFilter);
    const contextValue = (0, react_1.useMemo)(() => {
        return {
            id: id,
            defaultFilter: defaultFilter
        };
    }, [id, defaultFilter]);
    (0, react_1.useEffect)(() => {
        setFilter(id, (0, cloneDeep_1.default)(defaultFilter));
    }, [id, defaultFilter, setFilter]);
    return (react_1.default.createElement(FilterContext.Provider, { value: contextValue }, children));
};
exports.default = AdvanceFilter;
